import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  resetCall(event) {
    const call = this.element.querySelector(`[name="${event.target.name}_call"]`)
    if (call) {
      call.replaceChildren(new Option("Latest recorded call", ""))
      call.disabled = true
    }
  }
}
